// COMMON INPUT STYLES
import styled from 'styled-components';
import setMargin from '../../../helpers/setMargin';

const commonStyle = `
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 150%;
`;

export const placeholderStyle = ({ theme }) => `
  ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    ${commonStyle};
    color: ${theme.colors.lightGray};
  }
  ::-moz-placeholder { /* Firefox 19+ */
    ${commonStyle};
    color: ${theme.colors.lightGray};
  }
  :-ms-input-placeholder { /* IE 10+ */
    ${commonStyle};
    color: ${theme.colors.lightGray};
  }
  :-moz-placeholder { /* Firefox 18- */
    ${commonStyle};
    color: ${theme.colors.lightGray};
  }
`;

export const Field = styled.div`
  ${setMargin};
  width: ${({ w }) => w || '100%'};
  opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};
  position: relative;
`;

export const Label = styled.label`
  ${setMargin};
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: ${({ jc }) => jc || 'flex-start'};
`;
